import { FilterDateDashboard } from "../../../../components/Dashboard/ViewDatas/FilterDate";
import { ReactComponent as BagFood } from "../../../../assets/svg/icons/bagFood.svg";
import { DateModal } from "../../../../components/Modal/DateFilter";
import { useFilter } from "../../../../hooks/useFilter";
import Constants from "../../../../constants/Index";
import { useEffect, useRef, useState } from "react";
import { Dropdown } from "../../../../components/EditOnboarding/components/Select";
import { useForm } from "react-hook-form";
import { format } from "date-fns";
import ChartBar from "../../../../components/Graph/Bar";
import ChartBarLine from "../../../../components/Graph/BarLine";
import "../styles.css"
import { IOptionDoubleValuesProps, IOptionProps, IOptionsProps } from "../../../../@types/reactSelect/IOption";
import axios from "../../../../services/axios";
import { LeafletStaticMap } from "../../../../components/Leaflet/LeafletStaticMap/Index";
import { FlyToBounds, FlyToBoundsRefProps } from "../../../../components/Leaflet/FlyToBounds/Index";
import { Polygon } from "react-leaflet";

export default function DashboardManagementGeneral() {
    const {
        farmFilter,
        areasIdsFilter,
        rangeDays,
        setRangeDays,
        setHideMicroAreaFilter,
        setHideBatchFilter,
        setDashboard,
        setSideBarOptionSelected,
        setSelectRangeDate,
        snapshotMicroAreaMetrics,
        setSnapshotMicroAreaMetrics,
    } = useFilter();

    const {
        handleSubmit,
        control,
        watch,
        setValue,
    } = useForm();

    const [optionsTypeManagement, setOptionsTypeManagement] = useState<IOptionsProps>([]);
    const [managementOptions, setManagementOptions] = useState<IOptionsProps>();
    const [lotInst, setLotInst] = useState<IOptionsProps>([]);
    const [consumoSuplemment, setConsumoSuplemment] = useState<IOptionDoubleValuesProps>();
    const [prodAcumulada, setProdAcumulada] = useState<IOptionsProps>();
    const [areas, setAreas] = useState<IArea[]>();
    const [microAreas, setMicroAreas] = useState<IMicroArea[]>();
    const [microAreasSelected, setMicroAreasSelected] = useState<Number[]>();

    const typeManagement = watch("managementType")
    const groupManagement = watch("managementGroup")

    useEffect(() => {
        setHideMicroAreaFilter(true)
        setHideBatchFilter(true)
        setSideBarOptionSelected("DASHBOARD")
        setDashboard("MANAGEMENT")
        setSelectRangeDate(0)
        document.title = Constants.TITLE_DASHBOARD;

        axios
            .get("/micro-area-management/types")
            .then((response) => {
                const types: IOptionsProps = response.data.map((type: any) => ({
                    label: type.name,
                    value: type.id,
                    info: type.monitoring_types
                }))
                setOptionsTypeManagement(types.filter((type: any) => type.value != 1))
            })

        const now = new Date();
        const firstDayOfCurrentMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        const firstDayOfLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);

        setRangeDays({
            from: firstDayOfLastMonth,
            to: firstDayOfCurrentMonth
        })

        axios.get("/micro-areas").then(response => setMicroAreas(response.data))
    }, []);

    useEffect(() => {
        if (farmFilter) {
            axios.get(`/areas?farm_id=${farmFilter.id}`).then(response => setAreas(response.data))
        }
    }, [farmFilter]);

    useEffect(() => {
        if (farmFilter?.id && rangeDays && areas) {
            let startDate = format(rangeDays?.from ? new Date(rangeDays?.from) : new Date(), 'yyyy-MM-dd')
            let endDate = format(rangeDays?.to ? new Date(rangeDays?.to) : new Date(), 'yyyy-MM-dd')
            const defaultAreas = areas.map(area => area.id)

            axios.get(`/analytics/snapshots/management-groups?startDate=${startDate}&endDate=${endDate}&farmId=${farmFilter?.id}&${areasIdsFilter.length > 0 ? areasIdsFilter.map(area => `areaIds=${area.value}`).join("&") : defaultAreas.map(area => `areaIds=${area}`).join("&")}`)
                .then(response => setManagementOptions(response.data.map((option: IAnalyticsManagementGroups) => ({
                    label: `${option.management_type.name} - ${option.management_type.monitoring_types.map(el => el.name).join(",")}`,
                    value: option.management_group_id,
                    info: option
                }))))
        }
    }, [farmFilter, rangeDays, areas, areasIdsFilter]);

    useEffect(() => {
        if (rangeDays && areas) {
            let startDate = format(rangeDays?.from ? new Date(rangeDays?.from) : new Date(), 'yyyy-MM-dd')
            let endDate = format(rangeDays?.to ? new Date(rangeDays?.to) : new Date(), 'yyyy-MM-dd')

            if (groupManagement) {
                const microAreas = groupManagement.map((management: IOptionProps) => (management.info as IAnalyticsManagementGroups).micro_areas.map(microArea => microArea.id)).flat()

                axios.get(`/analytics/snapshots/micro-areas/metrics?startDate=${startDate}&endDate=${endDate}&${microAreas.length > 0 ? microAreas.map((microArea: number) => `areaIds=${microArea}`).join("&") : ""}`)
                    .then((response) => {
                        setSnapshotMicroAreaMetrics(response.data)
                    })
            }
        }
    }, [rangeDays, groupManagement]);

    useEffect(() => {
        if (snapshotMicroAreaMetrics) {
            setLotInst(snapshotMicroAreaMetrics.daily_metrics.map((inst) => ({
                label: inst.date,
                value: inst.average_instant_capacity_rate
            })))

            setConsumoSuplemment({
                data1: snapshotMicroAreaMetrics.daily_metrics.map(inst => ({
                    label: inst.date,
                    value: inst.average_consumption_kg_per_animal
                })),
                data2: snapshotMicroAreaMetrics.daily_metrics.map(inst => ({
                    label: inst.date,
                    value: inst.average_consumption_g_per_kg_pv
                }))
            })

            setProdAcumulada(snapshotMicroAreaMetrics.daily_metrics.map((inst) => ({
                label: inst.date,
                value: inst.strip_movements_count
            })))
        }
    }, [snapshotMicroAreaMetrics]);

    const OptionManagements = (option: any) => {
        const infoOption: IAnalyticsManagementGroups = option.data.info;
        const selectedValues = watch("managementGroup") || []

        function onSelect(option: any) {
            setValue("managementGroup", [...selectedValues, option.data])
        }

        return <div
            className="customDropdownOptions"
            style={{
                color: option.isSelected ? "#4D4D4D" : "#999999",
            }}
            onClick={() => onSelect(option)}
        >
            {infoOption.management_type.name} - {infoOption.management_type.monitoring_types.map(el => el.name).join(",")}
            <br />
            {infoOption.micro_areas.length > 0 ? infoOption.micro_areas.map(microArea => microArea.initials).join(" ") : ""}
        </div>
    }

    const flytoBoundsRef = useRef<FlyToBoundsRefProps>();

    useEffect(() => {
        if (groupManagement && groupManagement.length > 0) setMicroAreasSelected(groupManagement.map((management: IOptionProps) => (management.info as IAnalyticsManagementGroups).micro_areas.map(microArea => microArea.id)).flat())
    }, [groupManagement]);

    return (
        <div className="cattleMap_background" style={{ overflowY: "auto" }}>
            <form onSubmit={() => handleSubmit(() => { })} className="dashboardPastureManagement">

                <DateModal />

                <div className="cattleMap_page">
                    <div className="cattleMap_header">
                        <BagFood height={72} />
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                        }}>
                            <h2 className="cattleMap_title">
                                Manejo de Pasto
                            </h2>
                            <h3 className="cattleMap_subtitle">
                                Visualização Geral
                            </h3>
                        </div>
                    </div>

                    <div>
                        <FilterDateDashboard />
                        <div style={{ width: 400 }}>
                            <Dropdown
                                control={control}
                                label={"Tipo de pastejo"}
                                name={"managementType"}
                                placeholderText={"Selecione..."}
                                noOptionsMessage={() => "Nenhuma opção disponível"}
                                options={optionsTypeManagement}
                                isMulti
                            />

                            <Dropdown
                                control={control}
                                label={"Grupo de manejo"}
                                name={"managementGroup"}
                                placeholderText={"Selecione..."}
                                noOptionsMessage={() => "Nenhuma opção disponível"}
                                options={typeManagement ? managementOptions?.filter(option => Array.from(typeManagement.map(((type: IOptionProps) => type.value))).includes(`${option.info.management_type.id}`)) : []}
                                CustomOption={OptionManagements}
                                isMulti
                            />

                            {farmFilter && <div className="mapFilterManagement">
                                <LeafletStaticMap>
                                    <FlyToBounds ref={flytoBoundsRef} fitCoords={farmFilter.coords}>
                                        <Polygon
                                            dashArray={Constants.LEAFLET_DASHED_GREEN.dashArray}
                                            color={Constants.LEAFLET_DASHED_GREEN.color}
                                            fill={false}
                                            positions={farmFilter.coords}
                                        />
                                        {/* microArea */}
                                        {microAreas?.filter(microarea => microAreasSelected?.includes(microarea.id))?.map(microarea => <Polygon
                                            positions={microarea.map_coords!}
                                            color={Constants.LEAFLET_UNFOCUS_TRANSLUCENT.color}
                                            fillColor={Constants.LEAFLET_NORMAL_BLUE.fillColor}
                                            fillOpacity={
                                                Constants.LEAFLET_UNFOCUS_TRANSLUCENT.fillOpacity
                                            }
                                        />)}

                                    </FlyToBounds>
                                </LeafletStaticMap>
                            </div>
                            }
                        </div>
                    </div>
                </div>

                <br />

                <div className="content">
                    <ChartBar
                        titleGraph={"Taxa de lotação média no período"}
                        data={lotInst}
                        colorIcons={"Tx lotação média"}
                        axisLabels={["", "UA/ha"]}
                        fullWidth
                    />
                    <ChartBarLine
                        titleGraph={"Consumo de suplemento"}
                        dataColumn={consumoSuplemment?.data1 || []}
                        dataLine={consumoSuplemment?.data2 || []}
                        colorIcons={["Consumo médio no período (g/kgPV.dia)", "Consumo médio no período (kg/cab.dia)"]}
                        axisLabels={["", "g/kgPV.dia", "kg/cab.dia"]}
                        fullWidth
                    />
                    <ChartBar
                        titleGraph={"Produtividade acumulada no período"}
                        data={prodAcumulada}
                        colorIcons={"Produtividade acumulada"}
                        axisLabels={["", "Kg PV/ha"]}
                        fullWidth
                    />
                </div>
            </form >
        </div >
    );
}
